<div
    [formGroup]="contactsForm"
    *transloco="let t"
    class="bazis-contacts-control"
>
    <div
        formArrayName="contacts"
        *ngIf="{
            valueChanges: valueChanges$ | async,
            required: required$ | async,
        } as data"
    >
        <h6
            *ngIf="titleKey"
            class="bazis-text_secondary"
        >
            {{ t(titleKey) }}
            <span
                color="danger"
                *ngIf="data.required"
            >
                *
            </span>
        </h6>
        <div
            *ngFor="let contact of contacts.controls; let i = index"
            class="bazis-block bazis-contacts-control__group"
        >
            <div
                [formGroupName]="i"
                [id]="anchorRoot ? anchorRoot + '-' + i : null"
            >
                <bazis-toolbar
                    *ngIf="
                        (titleItemKey && max > 1) ||
                        (contacts.controls.length > min && contacts.enabled)
                    "
                >
                    <div
                        *ngIf="titleItemKey && max > 1"
                        slot="start"
                        class="bazis-text_major bazis-text_secondary bh-font-bold"
                    >
                        {{ t(titleItemKey, { number: i + 1 }) }}
                    </div>
                    <bazis-button
                        *ngIf="contacts.controls.length > min && contacts.enabled"
                        slot="end"
                        fill="outline"
                        (click)="removeContact(i)"
                    >
                        <bazis-icon
                            slot="icon-only"
                            [name]="icons.trash"
                        ></bazis-icon>
                    </bazis-button>
                </bazis-toolbar>

                <bazis-grid class="bazis-grid_form">
                    <bazis-row>
                        <bazis-col
                            sizeXl="4"
                            sizeXs="12"
                        >
                            <bazis-input-default
                                [id]="anchorRoot ? anchorRoot + '-last_name-' + i : null"
                                titleKey="title.last_name"
                                [required$]="required.$"
                                (touched)="markAsTouched()"
                                formControlName="last_name"
                                [sizeControl]="sizeControl"
                            ></bazis-input-default>
                        </bazis-col>
                        <bazis-col
                            sizeXl="4"
                            sizeXs="12"
                        >
                            <bazis-input-default
                                [id]="anchorRoot ? anchorRoot + '-first_name-' + i : null"
                                titleKey="title.first_name"
                                [required$]="required.$"
                                (touched)="markAsTouched()"
                                formControlName="first_name"
                                [sizeControl]="sizeControl"
                            ></bazis-input-default>
                        </bazis-col>
                        <bazis-col
                            sizeXl="4"
                            sizeXs="12"
                        >
                            <bazis-input-default
                                [id]="anchorRoot ? anchorRoot + '-middle_name-' + i : null"
                                titleKey="title.middle_name"
                                (touched)="markAsTouched()"
                                formControlName="middle_name"
                                [sizeControl]="sizeControl"
                            ></bazis-input-default>
                        </bazis-col>
                    </bazis-row>
                    <bazis-row>
                        <bazis-col
                            sizeXl="4"
                            sizeXs="12"
                        >
                            <bazis-input-default
                                [id]="anchorRoot ? anchorRoot + '-position-' + i : null"
                                titleKey="title.position"
                                (touched)="markAsTouched()"
                                formControlName="position"
                                [sizeControl]="sizeControl"
                            ></bazis-input-default>
                        </bazis-col>
                        <bazis-col
                            sizeXl="4"
                            sizeXs="12"
                        >
                            <div class="bh-flex bh-justify-content-between">
                                <bazis-input-default
                                    [id]="anchorRoot ? anchorRoot + '-phone-' + i : null"
                                    titleKey="title.phone"
                                    [required$]="required.$"
                                    (touched)="markAsTouched()"
                                    formControlName="phone"
                                    [maskSettings]="phoneMaskSettings"
                                    [beforeWrite]="phoneInputTransform"
                                    leftIcon="/assets/icons/other/phone.svg"
                                    [withoutInnerPadding]="true"
                                    [hasEraser]="false"
                                    [style.width]="'100%'"
                                    [sizeControl]="sizeControl"
                                ></bazis-input-default>
                                <div
                                    class="bh-margin-start-2x bh-shrink"
                                    [style.--control-width]="'60px'"
                                >
                                    <bazis-input-number
                                        title="&nbsp;"
                                        [placeholderKey]="'title.phone_additional'"
                                        (touched)="markAsTouched()"
                                        formControlName="phone_additional"
                                        [hasEraser]="false"
                                        [precision]="0"
                                        [maxNumber]="999999999"
                                        [sizeControl]="sizeControl"
                                    ></bazis-input-number>
                                </div>
                            </div>
                        </bazis-col>
                        <bazis-col
                            sizeXl="4"
                            sizeXs="12"
                        >
                            <bazis-input-default
                                [id]="anchorRoot ? anchorRoot + '-email-' + i : null"
                                titleKey="title.email"
                                [required$]="required.$"
                                (touched)="markAsTouched()"
                                formControlName="email"
                                rightIcon="envelope"
                                [sizeControl]="sizeControl"
                            ></bazis-input-default>
                        </bazis-col>
                    </bazis-row>
                </bazis-grid>
            </div>
        </div>

        <ng-container *ngIf="contacts.controls.length < max && contacts.enabled">
            <bazis-button
                *ngIf="addedGroupIsButton"
                color="action"
                fill="outline"
                (click)="addContactGroup()"
            >
                <bazis-icon
                    slot="start"
                    [name]="icons.plus"
                ></bazis-icon>
                {{ t(addButtonTitleKey) }}
            </bazis-button>

            <bazis-link
                *ngIf="!addedGroupIsButton"
                borderStyle="dashed"
                class="bh-font-medium"
                size="mini"
                (click)="addContactGroup()"
            >
                <bazis-icon
                    slot="start"
                    [name]="icons.plus"
                    size="regular"
                ></bazis-icon
                >{{ t(addButtonTitleKey) }}
            </bazis-link>
        </ng-container>
    </div>
</div>
